module.exports = __webpack_public_path__ + "img/15.1fff6b17.png";